var map = {
	"./cookies/feature-small.jpg": 104,
	"./marleyspoon/feature-small.jpg": 107,
	"./sketchrunner/feature-small.jpg": 109,
	"./stylemarks/feature-small.jpg": 114,
	"./zalando/feature-small.jpg": 120
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 446;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\/feature\-small\.jpg$
// module id = 446
// module chunks = 0